import React from 'react'
import { defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import Container from './Container'
import { getFirstKeyFromObject } from '../../../utils/formBuilder'

const animateLayoutChanges = args =>
  defaultAnimateLayoutChanges({ ...args, wasDragging: true })

const DroppableContainer = ({
  children,
  columns = 1,
  disabled,
  id,
  items,
  style,
  sectionIndex,
  activeSections,
  onShowHideSection,
  activeId,
  ...props
}) => {
  const {
    active,
    attributes,
    isDragging,
    listeners,
    over,
    setNodeRef,
    transition,
    transform
  } = useSortable({
    id,
    data: {
      type: 'container',
      children: items
    },
    animateLayoutChanges
  })

  const isOverContainer = over
    ? (id === over.id && active?.data.current?.type !== 'container') ||
      items.find(item => getFirstKeyFromObject(item) === over.id)
    : false

  return (
    <Container
      ref={disabled ? undefined : setNodeRef}
      sectionIndex={sectionIndex}
      activeSections={activeSections}
      onShowHideSection={onShowHideSection}
      style={{
        ...style,
        transition,
        transform: CSS.Translate.toString(transform),
        opacity: isDragging ? 0.5 : undefined
      }}
      isDraggingAny={!!activeId}
      hover={isOverContainer}
      handleProps={{
        ...attributes,
        ...listeners
      }}
      columns={columns}
      {...props}
    >
      {children}
    </Container>
  )
}

export default DroppableContainer
